// Hotfix menuGroups.js · Discovery + AI RAG reintegration · V12 Achromatic Strict.
// -----------------------------------------------------------------------------
// Additive extensions per il dropdown dashboard Sidebar.jsx. Zero-touch sul
// file base: `menuGroups.js` importa e applica `applyMenuDiscoveryExtensions`.
//
// Nuovo gruppo "Discovery" inserito DOPO "workspace" (anchor by `key`).
// Append `ai-rag` sotto il gruppo "ai_suite" esistente.
import {
    Compass,
    Target,
    FileText,
    Users,
    Database,
} from "lucide-react";

export const MENU_GROUPS_DISCOVERY_EXTENSIONS = {
    groupPatches: {
        ai_suite: {
            append: [
                { key: "ai-rag", labelKey: "admin_menu.item.ai_rag", label: "AI RAG", icon: Database, to: "/app/ai/rag", module: "ai" },
            ],
        },
    },
    newGroups: [
        {
            insertAfter: "workspace",
            group: {
                key: "discovery",
                headerKey: "admin_menu.group.discovery",
                label: "Discovery",
                items: [
                    { key: "discovery-leads",   labelKey: "admin_menu.item.lead_discovery",    label: "Lead Discovery (B2B)",   icon: Target,   to: "/app/leads/discovery",   module: "lead_engine" },
                    { key: "discovery-content", labelKey: "admin_menu.item.content_discovery", label: "Content Discovery",      icon: FileText, to: "/app/content/discovery", module: "lead_engine" },
                    { key: "discovery-social",  labelKey: "admin_menu.item.social_discovery",  label: "Social Discovery (B2C)", icon: Users,    to: "/app/social/discovery",  module: "lead_engine" },
                ],
            },
        },
    ],
};

// Icona Compass esportata per uso nei consumer (header dropdown chip).
export const DISCOVERY_GROUP_ICON = Compass;

/**
 * Merge MENU_GROUPS base + Discovery extensions · pure function.
 * @param {Array} baseGroups
 * @returns {Array} gruppi mergeati · ordine deterministico.
 */
export function applyMenuDiscoveryExtensions(baseGroups) {
    const groups = baseGroups.map((g) => {
        const patch = MENU_GROUPS_DISCOVERY_EXTENSIONS.groupPatches[g.key];
        if (patch?.append) {
            return { ...g, items: [...g.items, ...patch.append] };
        }
        return g;
    });
    const out = [];
    const pending = [...MENU_GROUPS_DISCOVERY_EXTENSIONS.newGroups];
    for (const g of groups) {
        out.push(g);
        for (let i = pending.length - 1; i >= 0; i--) {
            if (pending[i].insertAfter === g.key) {
                out.push(pending[i].group);
                pending.splice(i, 1);
            }
        }
    }
    if (pending.length > 0) {
        // eslint-disable-next-line no-console
        console.warn(
            "[menuGroups] discovery extensions con insertAfter non trovato:",
            pending.map((p) => p.group.key),
        );
        for (const p of pending) out.push(p.group);
    }
    return out;
}
